import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AppShellRouteSkeleton } from "@/components/skeletons";

function hasOwnerRole(studioRoles: { role: "Owner" | "Manager" | "Staff" }[] | undefined): boolean {
  return (studioRoles ?? []).some((studioRole) => studioRole.role === "Owner");
}

export default function PrivateRoute() {
  const { user, isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return <AppShellRouteSkeleton />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  // Check onboarding — owners go to onboarding, others see blocker
  const userIsOwner = hasOwnerRole(user.studioRoles);
  const studioOnboarded = (user.studios ?? []).some((s) => s.onboardingComplete);

  if (!user.onboardingComplete && !studioOnboarded) {
    if (userIsOwner) {
      return <Navigate to="/onboarding" replace />;
    }
    return <Navigate to="/setup-not-complete" replace />;
  }

  return <Outlet />;
}
